import { Icon } from "@iconify/react/dist/iconify.js";

export const VIDEO_KINDS = [
  { id: "tutorial", label: "Video de bienvenida", icon: "solar:play-circle-bold" },
  { id: "instrucciones", label: "Video de instrucciones", icon: "solar:book-2-bold" },
];

const VideoKindTabs = ({ activeKind, onChange, availability = {} }) => {
  return (
    <ul className="nav nav-pills gap-2 mb-3">
      {VIDEO_KINDS.map((k) => {
        const has = Boolean(availability[k.id]);
        return (
          <li className="nav-item" key={k.id}>
            <button
              type="button"
              className={`nav-link d-flex align-items-center gap-2 ${activeKind === k.id ? "active" : ""}`}
              onClick={() => onChange(k.id)}
            >
              <Icon icon={k.icon} width={18} />
              {k.label}
              {has && (
                <span
                  className="ms-1 rounded-circle bg-success"
                  style={{ width: 8, height: 8, display: "inline-block" }}
                  title="Video cargado"
                />
              )}
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default VideoKindTabs;
